
export function NoContent() {
    return <div>No content :(</div>
}